import { StandardEvents } from '@shopify/events';

/**
 * Preorder note under the buy buttons (blocks/buy-buttons.liquid).
 * Only the add-to-cart button is re-rendered when the size changes, so this element
 * updates itself from the same freshly rendered section HTML.
 */
class PreorderNote extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const target = this.closest('.shopify-section, dialog');
    target?.addEventListener(StandardEvents.productSelect, this.#onProductSelect, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = new AbortController();
  }

  /** @param {Event & { promise?: Promise<{ detail?: { html?: Document } }> }} event */
  #onProductSelect = async (event) => {
    try {
      const result = await event.promise;
      const next = result?.detail?.html?.querySelector(`preorder-note[data-block-id="${this.dataset.blockId}"]`);
      if (!next) return;
      this.hidden = next.hidden;
      this.innerHTML = next.innerHTML;
    } catch {
      // Aborted or failed variant fetch: keep the current note
    }
  };
}

if (!customElements.get('preorder-note')) customElements.define('preorder-note', PreorderNote);
